import theme from './default/index';

import pattern from '../../assets/pattern.png';
import styled from 'styled-components';

export const Pattern = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: none;
  background-image: url(${pattern});
  background-repeat: repeat;
  opacity: 0.5;
  z-index: -1;
`;

export const ThemeDefinitions = theme;

export default ThemeDefinitions;